// extracted by mini-css-extract-plugin
export var growableInput = "_4w-0";
export var tagContainer = "_4w-2";
export var textInput = "_4w-1";